module.exports = require('./bundle-url').getBundleURL() + "logo.21fe0991.png"